export default {
  title: 'Registrace',

  BuildingSearch: {
    heading: 'Zadejte adresu a vyhledejte Váš dům',
    Form: {
      Fields: {
        AddressId: {
          label: 'Adresa vašeho domu',
          placeholder: 'Začněte psát adresu vašeho domu',
          minLength: 'Napište minimálně čtyři znaky',
          noData: 'Na vámi zadané adrese nebyla nalezena žádná budova',
        },
        Submit: {
          title: 'Hledat dům',
        },
      },
    },
  },

  BuildingConfirm: {
    heading: 'Dům na adrese <0>{{address}}</0> je možné zaregistrovat do aplikace eVlastníci.',
    headingRegistered: 'Dům na adrese <0>{{address}}</0> je již zaregistrovaný.',
    headingDeactivated: 'Dům na adrese <0>{{address}}</0> je momentálně deaktivovaný.',
    headingNotValidType: 'Dům na adrese <0>{{address}}</0> bohužel nelze zaregistrovat.',
    subheading: 'Zaregistrujte ho během několika minut.',
    subheadingRegistered:
      'Tento dům už v aplikaci někdo spravuje. O přístup požádejte statutární orgán SVJ — předsedu nebo člena výboru. Někdo z nich už přístup do aplikace pravděpodobně má.',
    subheadingDeactivated:
      'Tento dům byl v aplikaci registrovaný, ale je nyní deaktivovaný. Pro obnovení přístupu kontaktujte prosím naši podporu.',
    subheadingNotValidType: 'Pokud si myslíte, že jde o omyl, obraťte se prosím na naši podporu.',
    housingCooperativeWarningTitle: 'Pozor, na této adrese jsme našli pouze bytové družstvo',
    housingCooperativeWarningText:
      'V rejstříku jsme na adrese našli pouze {{name}}. Aplikace eVlastníci zatím neumožňuje online hlasování v bytových družstvech. V registraci pokračujte, pouze pokud ve vašem domě již vzniklo společenství vlastníků.',
    nextStep: 'Zaregistrovat dům',
    prevStep: 'Změnit adresu',
    contactSupport: 'Kontaktovat podporu',
  },

  LegalEntity: {
    heading: 'Vyplňte údaje k vašemu SVJ na adrese {{address}}.',
    prefillNoteTitle: 'Údaje o vašem SVJ jsme předvyplnili z veřejného rejstříku',
    prefillNoteText: 'Zkontrolujte je prosím a případně upravte.',
    Form: {
      Fields: {
        Company: {
          label: 'Název vašeho SVJ',
          placeholder: 'Zadejte název vašeho SVJ',
          required: 'Název SVJ musí být vyplněný',
        },
        AddressId: {
          label: 'Adresa sídla SVJ',
          placeholder: 'Zadejte adresu sídla SVJ',
          required: 'Adresa sídla SVJ je povinná',
          minLength: 'Napište minimálně čtyři znaky',
          noData: 'Na vámi zadané adrese nebyla nalezena žádná budova',
        },
        CompanyId: {
          label: 'IČO',
          placeholder: 'Zadejte IČO vašeho SVJ',
          required: 'IČO musí být vyplněné',
        },
        TaxId: {
          label: 'DIČ',
          placeholder: 'Zadejte DIČ vašeho SVJ',
          required: 'DIČ musí být vyplněné',
        },
        Admin: {
          label: 'Potvrzuji, že jsem osoba oprávněná rozhodovat o záležitostech vybraného SVJ',
          required: 'Toto pole musí být zaškrtnuto',
        },
        IsPermitted: {
          label:
            'Beru na vědomí, že pro používání aplikace musí být stanovy vybraného SVJ v souladu s doporučením služby eVlastníci. Vice informací lze nalézt stránce',
          label_2: 'Stanovy',
          required: 'Toto pole musí být zaškrtnuto.',
        },

        Submit: {
          title: 'Přejít k registaci přihlašovacího účtu',
        },
      },
    },
  },

  User: {
    heading: 'Registrujete se jako správce nemovitosti {{address}}.',
    Form: {
      Fields: {
        FirstName: {
          label: 'Jméno',
          placeholder: 'Vaše jméno',
          required: 'Jméno musí být vyplněné',
        },
        LastName: {
          label: 'Příjmení',
          placeholder: 'Vaše příjmení',
          required: 'Příjmení musí být vyplněné',
        },
        Email: {
          label: 'Email',
          placeholder: 'Např. e-mail vašeho SVJ',
        },
        Phone: {
          label: 'Telefon',
          placeholder: 'Zadejte vaše telefonní číslo, např. +420 xxx xxx xxx',
          required: 'Telefon je povinný',
        },
        Password: {
          label: 'Heslo',
          placeholder: 'Zadejte vaše heslo',
        },
        PasswordCheck: {
          label: 'Heslo znovu',
          placeholder: 'Zadejte heslo znovu',
          matches: 'Hesla se musí shodovat',
        },
        Submit: {
          title: 'Registrovat se',
        },
      },
    },
    EmailTip: {
      title: 'Vlastníte v tomto domě jednotku?',
      text: 'Jeden e-mail může v aplikaci patřit jen jednomu účtu. Pokud v tomto domě zároveň vlastníte jednotku a chcete v něm hlasovat, zaregistrujte správcovský účet na e-mail SVJ nebo výboru. Osobní e-mail si nechte pro svůj účet vlastníka.',
    },
    ExistingAccount: {
      heading: 'Účet s e-mailem {{email}} už existuje',
      subheading: 'Přihlaste se svým heslem a dům zaregistrujete pod tímto účtem. Stanete se jeho správcem.',
      ownerTip:
        'Pokud je to váš účet vlastníka jednotky v tomto domě, použijte pro správu raději jiný e-mail (např. e-mail SVJ). Jeden účet nemůže být v jednom domě zároveň správcem i hlasujícím vlastníkem.',
      Password: {
        label: 'Heslo',
        placeholder: 'Zadejte vaše heslo',
        required: 'Heslo je povinné',
      },
      Submit: {
        title: 'Přihlásit se a pokračovat',
      },
      useDifferentEmail: 'Použít jiný e-mail',
      forgottenPassword: 'Zapomenuté heslo?',
      error: 'Nesprávné přihlašovací údaje, zkuste to prosím znovu.',
    },
    Authenticated: {
      heading: 'Dům zaregistrujete pod účtem {{email}}',
      subheading:
        'Stanete se správcem domu na adrese {{address}}. Mezi svými domy pak můžete v aplikaci kdykoliv přepínat.',
      Submit: {
        title: 'Pokračovat',
      },
      switchAccount: 'Přihlásit se pod jiným účtem',
    },
  },

  Summary: {
    heading: 'Shrnutí objednávky',
    Form: {
      title: 'Registrujete se jako správce k domu na adrese {{address}}.',
      existingAccountInfo: 'Dům registrujete pod svým stávajícím účtem {{email}}.',
      unitsSummary: 'Dům má celkem {{units}} jednotek.',
      fieldsTitle: 'Potřebujeme od vás pár formalit k úspěšnému dokončení registrace:',
      Fields: {
        Gdpr: {
          label: 'Beru na vědomí ',
          label_2: 'prohlášení o ochraně osobních údajů',
          required: 'K dokončení registrace od vás potřebujeme souhlas k prohlášení o ochraně osobních údajů.',
        },
        License: {
          label: 'Souhlasím s',
          label_2: 'licenční smlouvou',
          required: 'K dokončení registrace od vás potřebujeme souhlas s licenční smlouvou.',
        },
        TermsAndConditions: {
          label: 'Souhlasím s',
          label_2: 'všeobecnými obchodními podmínkami',
          required: 'K dokončení registrace od vás potřebujeme souhlas s všeobecnými obchodními podmínkami.',
        },
        Marketing: {
          label: 'Souhlasím se',
          label_2: 'zpracováním mých osobních údajů',
        },
        PromoCode: {
          toggleText: 'Mám promo kód',
          label: 'Promo kód',
          placeholder: 'Zadejte váš promo kód',
        },
        Submit: {
          title: 'Dokončit registraci',
        },
      },
    },
    Loading: {
      FetchingFailed: {
        headingMessage: 'Při registraci nastala chyba',
        heading: 'Nepodařilo se stáhnout data domu',
        subheading: 'Nepodařilo stáhnout data vašeho domu, prosím kontaktujte technickou podporu.',
        buttonTitle: 'Kontaktovat podporu',
        buttonAgain: 'Začít znovu',
      },
      RegistrationFailed: {
        heading: 'Nepodařilo se zaregistrovat dům',
        subheading: 'Při registraci nastala chyba, zkuste registraci znovu nebo kontaktujte naší technickou podporu.',
        buttonTitle: 'Kontaktovat podporu',
      },
      string0: '',
      string1: 'Právě pro vás připravujeme vaší budovu',
      string2: 'Shromažďujeme veškerá potřebná data',
      string3: 'Stahujeme data z registru nemovitostí',
      string4: 'Dokončujeme stahování',
    },
  },

  IncompleteData: {
    heading: 'Bohužel od vás nemáme všechny potřebné informace k registraci, začněte prosím znovu.',
    buttonTitle: 'Začít znovu',
  },
};
